module.exports = __webpack_public_path__ + "static/img/visual-02-m.d4508450.jpg";